import { createFileRoute } from "@tanstack/react-router";
import LansareAmbarcatiuni from "@/pages/LansareAmbarcatiuni";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/lansare-ambarcatiuni/")({
  head: () => routeHead("/lansare-ambarcatiuni/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LansareAmbarcatiuni />
  );
}
